import React from 'react';

const Footer = () => {
    const currentYear = new Date().getFullYear();
    const systemName = process.env.REACT_APP_SYSTEM_NAME || 'ระบบลงนามถวายพระพรชัยมงคล';
    const organization = process.env.REACT_APP_ORGANIZATION || 'www.kruwirat.com';
    const logoUrl = process.env.REACT_APP_LOGO_URL;
    
    return (
        <footer style={{
            background: 'var(--gradient-dark)',
            color: 'white',
            padding: '20px 0',
            marginTop: 'auto',
            boxShadow: '0 -2px 10px rgba(0,0,0,0.1)'
        }}>
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-md-6 text-center text-md-start">
                        <p className="mb-0">
                            <strong>{currentYear} © {systemName}</strong>
                        </p>
                    </div>
                    <div className="col-md-6 text-center text-md-end">
                        <div className="d-flex align-items-center justify-content-center justify-content-md-end">
                            <img src={logoUrl} 
                                 alt="Developer Logo" 
                                 style={{
                                     width: '30px',
                                     height: '30px',
                                     borderRadius: '50%',
                                     marginRight: '10px',
                                     border: '2px solid white'
                                 }} />
                            <span>ผู้พัฒนาโดย : <a href={`https://${organization}`} 
                                                  target="_blank" 
                                                  rel="noopener noreferrer"
                                                  style={{ color: '#4DA8DA', textDecoration: 'none' }}>
                                {organization}
                            </a></span>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;